import React from 'react';

// Components
import { CardDetail } from '@arredo/reactjs-ui';

// Others
import OrderTotals from '../../../components/orderTotals';

const TotalsDetail = ({ order }) =>
    <CardDetail title='Resumen venta'>
        <OrderTotals
            order={order}
            totalPayedAmount={order.amount}
        />
    </CardDetail>

export default TotalsDetail;